import { useGet, usePost } from "../common/fetchServices";
import { API_BASE_URL, STIP_BASE_URL } from "../props";

export const useRipEndpoints = () => {
  const url = `${STIP_BASE_URL}/rip-endpoint`;
  return useGet(["rip-endpoints"], url);
};

export const useRipEndpointCreate = () => {
  const url = `${STIP_BASE_URL}/rip-endpoint`;
  return usePost(() => url, {
    queriesToInvalidate: [["rip-endpoints"]],
  });
};

export const useAllModules = () => {
  const url = `${API_BASE_URL}/admin/modules?limit=all`;
  return useGet(["modules-all"], url);
};
